import { Modal, Button } from "@mantine/core";
import { IconXboxXFilled } from "@tabler/icons-react";
import { useIdleTimeContext } from "./IdleTimeContext";
import { useNavigate } from "react-router-dom";

export const ExitModal = () => {
  const { taskExpired } = useIdleTimeContext();
  const navigate = useNavigate();
  return (
    <Modal
      opened={taskExpired}
      onClose={() => {}}
      title="Task No Longer Available"
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      overlayProps={{
        backgroundOpacity: 0.6,
        blur: 3,
      }}
      zIndex={10200}
      lockScroll={false}
      withinPortal
      portalProps={{ target: "body" }}
      styles={{
        overlay: { position: "fixed", inset: 0 },
        inner: { position: "fixed", inset: 0 },
      }}
    >
      <div className="flex flex-col items-center gap-6 py-4">
        <div className="flex h-16 w-16 items-center justify-center">
          <IconXboxXFilled size={50} color="red" />
        </div>

        <div className="text-center">
          <p className="text-gray-600">
            This task has been unassigned due to inactivity.
          </p>
        </div>

        <Button
          onClick={() => {
            navigate("/");
          }}
          variant="filled"
          size="md"
          fullWidth
        >
          Back to Dashboard
        </Button>
      </div>
    </Modal>
  );
};
